// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"cd4f8282","232":"8d7fe59e","237":"072bec48","364":"2e5bb949","512":"e69f89b5","526":"d3563578"}[chunkId] + ".chunk.js";
};